import React from 'react';

const GraphQLIcon = () => {
  return <img src='/skill-icons/graphql.png' alt='graphql-logo' />;
};

export default GraphQLIcon;
